import { render, staticRenderFns } from "./MoreMenuSection.vue?vue&type=template&id=13432168&scoped=true"
import script from "./MoreMenuSection.vue?vue&type=script&lang=js"
export * from "./MoreMenuSection.vue?vue&type=script&lang=js"
import style0 from "./MoreMenuSection.vue?vue&type=style&index=0&id=13432168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13432168",
  null
  
)

export default component.exports